import { getFandomContext } from "../../helpers/getFandomContext";
import type { SlotConfig } from "../../config/platforms/types";

const MAX_RANDOM_NUMBER = 10_000_000_000;

/**
 * Generates a truly random, positive integer to be used as a correlator.
 * This value should not be reused across page views to ensure uniqueness.
 */
function generateCorrelator(): number {
  return Math.floor(Math.random() * MAX_RANDOM_NUMBER) + 1;
}

export function getStaticParams(): string[] {
  return [
    "output=xml_vast4",
    "env=vp",
    "gdfp_req=1",
    "impl=s",
    "unviewed_position_start=1",
    `url=${encodeURIComponent(window.location.href)}`,
    `description_url=${encodeURIComponent(window.location.href)}`,
    `correlator=${generateCorrelator()}`,
  ];
}

export function getPpidParam(): string[] {
  const ppid = getFandomContext()?.tracking?.ppid;
  return ppid ? [`ppid=${ppid}`] : [];
}

export function getSlotSize(slotConfig?: SlotConfig): string {
  if (!slotConfig) {
    return "";
  }

  const sizes = slotConfig.sizes;
  return Array.isArray(sizes)
    ? sizes.map((size) => size.toString().replace(",", "x")).join("|")
    : "640x480";
}

/**
 * Sets the ad unit path as a runtime variable in the global window.ads object.
 * This makes the ad unit path accessible to Connatix player on the page.
 *
 * @param adUnit - The ad unit path to be stored
 */
export function setVideoAdUnitRuntimeVariable(adUnit: string): void {
  if (window.ads && adUnit) {
    window.ads.runtime = window.ads.runtime ?? {};
    window.ads.runtime.video = { adUnit };
  }
}
